import { NativeAudio } from "@ionic-native/native-audio";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { MerchantRentalYourspacePage } from "./../merchant-rental-yourspace/merchant-rental-yourspace";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { TranslateService } from "@ngx-translate/core";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-shop-refill-stock",
  templateUrl: "merchant-shop-refill-stock.html",
})
export class MerchantShopRefillStockPage {
  result: any = { space_no: "", add: "", cost: "" };
  plaza = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private translateService: TranslateService,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private alertCtrl: AlertController,
    private nativeAudio: NativeAudio,
    private loadingCtrl: LoadingController
  ) {
    this.result = this.navParams.data.space;
    this.nativeAudio.preloadSimple("uniqueId2", "assets/sounds/cash.aac");

    this.storage.get("info").then((info) => {
      if (info.team.plaza_id == 1) {
        this.plaza = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza = "F";
      } else {
        this.plaza = info.team.plaza_id;
      }
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.result.add =
      parseFloat(this.result.shop.max_stock) -
      parseFloat(this.result.availableTicket);
    this.result.cost = this.result.shop.cost;

    let total = parseFloat(this.result.add) * parseFloat(this.result.cost);
    this.result.total_cost = this.services.currencyFormat(total);
  }

  confirm() {
    const confirm = this.alertCtrl.create({
      // title: 'Remove this shop?',
      message:
        "ADD " +
        this.result.add +
        " ITEMS TO THE SHOP<br/>COST = " +
        this.result.cost +
        " PER UNIT<br/>TOTAL COST " +
        this.result.total_cost +
        " BATH",
      buttons: [
        {
          text: "Yes",
          handler: () => {
            const loader = this.loadingCtrl.create({
              content: "Loading...",
            });
            loader.present();

            // console.log('Agree clicked');
            this.storage.get("token").then((token) => {
              var link =
                this.services.URLMerchantSpace +
                "/" +
                this.result.space_no +
                "/stock";
              let body = "space_no=" + this.result.space_no;

              var headers = new Headers();
              headers.append(
                "Content-Type",
                "application/x-www-form-urlencoded"
              );
              headers.append("Accept", "application/json");
              headers.append("Authorization", "Bearer " + token);
              const requestOptions = new RequestOptions({ headers: headers });

              this.http
                .post(link, body, requestOptions)
                .map((res) => res.json())
                .subscribe(
                  (data) => {
                    this.nativeAudio.play("uniqueId2");
                    loader.dismiss();
                    this.navCtrl.push(MerchantRentalYourspacePage);
                  },
                  (error) => {
                    var response = JSON.parse(error._body);
                    loader.dismiss();
                    this.translateService
                      .get(response.message)
                      .subscribe((value) => {
                        this.services.presentToast(value);
                      });
                  }
                );
            });
          },
        },
        {
          text: "No",
          cssClass: "btn-no",
          handler: () => {
            // console.log('Disagree clicked');
          },
        },
      ],
    });
    confirm.present();
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-refill-stock/merchant-shop-refill-stock.ts